// src/store/actions.ts
import { createAction } from '@reduxjs/toolkit';
import { AppDispatch } from './store';

export const logout = createAction('auth/logout');
